export const isBrowser = () => typeof window !== "undefined"
export const isSSR = () => typeof window === "undefined"

export const DATADOG_USER_AGENT = "DatadogSynthetics"

export function isProduction() {
  const env = process.env.GATSBY_ENV || process.env.NODE_ENV
  return env === "production"
}
